import React from "react";
import { useWizard } from "react-use-wizard";
import { Button } from "../../../Actions";
import { RulesTable } from "../../../RulesTable/RulesTable";
import { StepContent } from "../Components";

const Rules: React.FC = () => {
  const { nextStep } = useWizard();

  return (
    <StepContent
      title="Here are the rules:"
      description="You'll be paired with another, anonymous invitee, and you'll both be asked whether you'd like to trust or distrust the other player.">
      <RulesTable />
      <Button
        analyticsProperty="Rules: Play Game"
        modifier="primary"
        onClick={() => nextStep()}>
        Play
      </Button>
    </StepContent>
  );
};

export default Rules;
